<mat-spinner
  [mode]="
    percentage !== undefined && percentage !== null && percentage !== 100
      ? 'determinate'
      : 'indeterminate'
  "
  [value]="percentage"
  [diameter]="size ? size : 100"
></mat-spinner>
